import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { t, user } from '../i18n';
import { Field, Input, Flash } from '../ui';

const bootstrap = window.__P4N__ || {};
const RECAPTCHA_SITE_KEY = '6LeMXKQkAAAAABXsd3RzLyHtDVZaLxrhM-tcuXmf';

/**
 * Page de connexion. Le formulaire est soumis en POST classique vers
 * premium.auth.login (session + redirection serveur), avec reCAPTCHA v2
 * en production — même mécanique que l'ancienne page.
 */
export default function Login() {
    useEffect(() => {
        if (!bootstrap.recaptcha) return;
        // Callback global attendu par le bouton .g-recaptcha
        window.onSubmit = () => document.getElementById('login-form').submit();
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        document.head.appendChild(script);
        return () => { document.head.removeChild(script); };
    }, []);

    if (user) return <Navigate to="/" replace />;

    return (
        <div className="login-layout">
            <div className="login-layout__panel">
                <img className="login-layout__logo" src="/assets/ds/img/logo-horizontal.svg" alt="park4night" />
                <h1 className="login-layout__title">{t('login_label_web')}</h1>
                <hr className="dashed-divider" style={{ marginTop: 12 }} />

                {bootstrap.flash && bootstrap.flash.error && <Flash type="error">{bootstrap.flash.error}</Flash>}
                {bootstrap.flash && bootstrap.flash.success && <Flash type="success">{bootstrap.flash.success}</Flash>}

                <form id="login-form" method="POST" action={bootstrap.urls.login}>
                    <span dangerouslySetInnerHTML={{ __html: bootstrap.csrfInput || '' }} />
                    <Field label={t('username')}>
                        <Input name="username" type="text" required autoFocus autoComplete="username" />
                    </Field>
                    <Field label={t('password')}>
                        <Input name="password" type="password" required autoComplete="current-password" />
                    </Field>
                    {bootstrap.recaptcha ? (
                        <button
                            type="submit"
                            className="btn btn--gradient btn--lg btn--block g-recaptcha"
                            data-sitekey={RECAPTCHA_SITE_KEY}
                            data-callback="onSubmit"
                            data-action="submit"
                        >
                            {t('se_connecter')}
                        </button>
                    ) : (
                        <button type="submit" className="btn btn--gradient btn--lg btn--block">
                            {t('se_connecter')}
                        </button>
                    )}
                </form>
            </div>

            <div className="login-layout__hero">
                <div className="p4n-duotone">
                    <img src="/assets/ds/img/photo-van.png" alt="" />
                </div>
                <div className="login-layout__tagline">The world is my garden.</div>
            </div>
        </div>
    );
}
